import axiosInstance from '../config/axios';

/**
 * Fetch FAQs list from backend API (GET /faq)
 */
export const getFaqsApi = async () => {
  try {
    const res = await axiosInstance.get('/faq');
    return res.data;
  } catch (error) {
    try {
      const res2 = await axiosInstance.get('/faqs');
      return res2.data;
    } catch (error2) {
      throw error;
    }
  }
};
